<template>
  <!-- 商品价格区域 -->
  <div class="good-price-area" :style="(customStyle && customStyle.root) || {}">
    <!-- 商品总价占位符【用于保证商品模块高度和内部元素位置】 -->
    <!-- 【商品单价 [会员价 | 划线价] 加购按钮】 -->
    <div
      :class="['good-price', customOperator.type === 'large' ? 'large' : '']"
    >
      <!-- 未登录价格保护 -->
      <div v-if="ssuInfo.ssuPrice.priceShield" class="price-shield">
        {{ ssuInfo.ssuPrice.priceShieldText }}
      </div>
      <!-- 价格部分 -->
      <div v-else class="price">
        <!-- 商品单价 -->
        <p :class="['unit-price', !showOriginalPrice ? 'fill' : '']">
          <span
            class="prefix-price"
            :style="showDiscountPrice && predictPrice ? 'color: #262626;' : ''"
            >{{ unitPrice.prefix }}</span
          >
          <span
            class="value"
            :style="
              ((customStyle && customStyle.totalPrice) || {},
              showDiscountPrice && predictPrice ? 'color: #262626;' : '')
            "
            >{{ unitPrice.price }}</span
          >
          <span
            v-if="ssuInfo.ssuPrice.unitPrice"
            class="unit"
            :style="showDiscountPrice && predictPrice ? 'color: #262626;' : ''"
            >/{{ unitPrice.unit }}</span
          >
          <!-- 商品总价 -->
          <span
            v-if="ssuInfo.ssuPrice.totalPriceWithFp"
            class="good-total-price"
          >
            {{ '￥' + ssuInfo.ssuPrice.totalPriceWithFp }}
          </span>
        </p>
      </div>
      <!-- 加购按钮部分 -->
      <div v-if="customOperator.type === 'normal'" class="operator-wrapper">
        <new-operator
          :use-simple="customOperator.simple"
          :use-arrived-notice-icon="customOperator.useArrivedNoticeIcon"
          show-simple-count
          :show-promote-tip="customOperator.showPromoteTip"
          :ssu="ssu"
          :is-hint="isHint"
          @add="addGoods"
          @subtract="subtractGoods"
          @goDetail="goDetail"
        />
      </div>
    </div>

    <div class="extra-price">
      <!-- 划线价 -->
      <div v-if="showOriginalPrice" class="original-price">
        {{ '￥' + ssuInfo.ssuPrice.crossedPrice }}
      </div>
    </div>

    <div class="discount-wrapper">
      <!-- 2、3 * n 的划线价 -->
      <div v-if="showMultOriginalPrice" class="mult-original-price">
        {{ '￥' + ssuInfo.ssuPrice.crossedPrice }}
      </div>
      <!-- 优惠后单价 -->
      <div v-else-if="showDiscountPrice && predictPrice" class="discount-price">
        {{ predictPrice }}
      </div>
    </div>

    <!-- 加购按钮部分 -->
    <div v-if="customOperator.type === 'large'" class="operator-wrapper-large">
      <new-operator
        :use-simple="customOperator.simple"
        :use-icon="false"
        :btn-text="'加入购物车'"
        :btn-width="customOperator.btnWith || 1.92"
        :btn-type="'large'"
        :use-arrived-notice-icon="customOperator.simple"
        show-simple-count
        :show-promote-tip="customOperator.showPromoteTip"
        :ssu="ssu"
        :show-can-not-buy="false"
        @add="addGoods"
        @subtract="subtractGoods"
        @goDetail="goDetail"
      />
    </div>
  </div>
</template>

<script>
import NewOperator from '@/common/widgets/newOperator/newIndex.vue'
export default {
  components: {
    NewOperator
  },
  props: {
    ssu: {
      type: Object,
      default: () => {}
    },
    ssuInfo: {
      type: Object,
      default: () => {}
    },
    showGoodPrice: {
      type: Boolean,
      default: true
    },
    showOriginalPrice: {
      type: Boolean,
      default: false
    },
    showMultOriginalPrice: {
      type: Boolean,
      default: false
    },
    showDiscountPrice: {
      type: Boolean,
      default: false
    },
    totalPricePlaceholder: {
      type: Boolean,
      default: false
    },
    customOperator: {
      type: Object,
      default: () => {
        return {
          simple: true,
          showPromoteTip: false,
          type: 'normal'
        }
      }
    },
    customStyle: {
      type: Object,
      default: () => {}
    },
    fromPage: {
      type: String,
      default: ''
    },
    isHint: {
      type: Number,
      default: 0
    }
  },
  computed: {
    // 单价展示处理
    unitPrice() {
      const approximateShow = this.ssuInfo.ssuPrice.isShowWeightUnitPrice === 1
      return {
        prefix: approximateShow ? '约￥' : '￥',
        price: this.ssuInfo.ssuPrice[
          approximateShow ? 'weightUnitPrice' : 'unitPrice'
        ],
        unit: this.ssuInfo.ssuPrice[
          approximateShow ? 'weightPriceUnit' : 'priceUnit'
        ]
      }
    },
    // 优惠后价格
    predictPrice() {
      if (
        !this.ssuInfo.ssuPrice?.isPredictPrice ||
        !this.ssuInfo?.predictSsuUnitPriceText
      ) {
        return ''
      }

      return `
        ${this.ssuInfo.ssuPrice?.predictSsuUnitPriceText?.predictTypeMsgPrefix}
        ${this.ssuInfo.ssuPrice?.predictSsuUnitPriceText?.priceSymbol}
        ${this.ssuInfo.ssuPrice?.predictSsuUnitPriceText?.predictShowPrice}
        ${this.ssuInfo.ssuPrice?.predictSsuUnitPriceText?.predictPriceUnitSuffix}
      `
    }
  },
  methods: {
    // 统一商品模块埋点上报方法
    tracerReport(type) {
      this.$track(
        this.$trackMap.similarGoods[this.ssuInfo.traceType],
        this.ssuInfo.traceInfo
      )
    },
    // 商品加购处理
    addGoods() {
      if (this.fromPage === 'similar') {
        // 加购埋点
        this.tracerReport('addcart')
      } else {
        this.$emit('beforeAddGoods')
      }
    },
    // 商品减购处理
    subtractGoods() {},
    goDetail() {
      this.$emit('goDetail')
    }
  }
}
</script>

<style lang="scss" scoped>
// .good-price-area {
//   margin-top: 0.24rem;
// }

.good-total-price {
  height: 0.34rem;
  margin-bottom: -0.1rem;
  margin-left: 0.16rem;

  font-size: 0.26rem;
  line-height: 0.34rem;
  color: #8c8c8c;

  &-placeholder {
    height: 0.34rem;
    margin-bottom: -0.1rem;

    line-height: 0.34rem;
  }
}

.operator-wrapper-large {
  margin-top: 0.08rem;
}

.good-price {
  @include flex(row, space-between, center, nowrap);
  &.large {
    margin-top: 0.1rem;
  }
  .price-shield {
    font-size: 0.24rem;
    line-height: 0.32rem;
    color: #f03100;
  }

  .price {
    overflow: hidden;

    flex: auto;

    @include flex(row, flex-start, flex-end, nowrap);

    ::v-deep .member-price {
      margin-left: 0.12rem;

      flex: none;
    }

    .unit-price {
      flex: none;

      font-size: 0.32rem;
      white-space: nowrap;
      &.fill {
        flex: auto;

        color: #8c8c8c;
        @include text-overflow-ellipsis-single;
      }

      .prefix-price {
        font-size: 0.2rem;

        font-weight: bold;
        color: #ff5c00;
      }

      .value {
        font-size: 0.36rem;
        font-weight: 700;
        color: #ff5c00;
      }

      .unit {
        margin-left: 0.04rem;

        font-size: 0.24rem;
        font-weight: bold;

        color: #ff5c00;
      }
    }
  }

  .operator-wrapper {
    flex: none;
  }
}

.extra-price {
  @include flex(row, normal, center, nowrap);

  .original-price {
    margin-left: 0.12rem;

    font-size: 0.24rem;
    text-decoration: line-through;

    color: $c-text-lighter;
    @include text-overflow-ellipsis-single;
  }
}

.discount-wrapper {
  height: 0.36rem;

  line-height: 0.36rem;
}
.discount-price {
  @include text-overflow-ellipsis-single;
  @include text(0.24rem, #ff5c00, true);
}
.mult-original-price {
  text-decoration: line-through;
  @include text-overflow-ellipsis-single;
  @include text(0.24rem, #999);
}
</style>
